export const actionKey = '@@uploads';
